var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkdin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3227_3773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9726 0.0546875C7.59844 0.0546875 0 7.65312 0 17.0273C0 26.4005 7.59844 34 16.9726 34C26.3468 34 33.9453 26.4005 33.9453 17.0273C33.9453 7.65312 26.3468 0.0546875 16.9726 0.0546875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.771 24.3909V17.8808C25.771 14.3929 23.9094 12.7699 21.4261 12.7699C19.4222 12.7699 18.5248 13.8721 18.0252 14.6454V13.0362H14.2509C14.3007 14.1023 14.2509 24.3909 14.2509 24.3909H18.0252V18.0495C18.0252 17.7111 18.0496 17.3716 18.1493 17.1298C18.4219 16.4519 19.0425 15.7497 20.0852 15.7497C21.4515 15.7497 21.9978 16.7903 21.9978 18.3168V24.3919L25.771 24.3909ZM10.274 11.4864C11.5894 11.4864 12.4093 10.6133 12.4093 9.5239C12.3849 8.41007 11.5894 7.5625 10.2984 7.5625C9.00739 7.5625 8.16406 8.41007 8.16406 9.5239C8.16406 10.6144 8.98299 11.4864 10.2506 11.4864H10.274ZM12.1611 24.3909V13.0362H8.38789V24.3909H12.1611Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3227_3773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.9453,
    height: 33.9453,
    fill: "white",
    transform: "translate(0 0.0546875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.6b8849f0d748aba171c65e21c96d280a.svg";
export { ForwardRef as ReactComponent };